import useLocalStorage from "./useLocalStorage";

function useSettings() {
  const [shouldHighlightWords, setShouldHighlightWords] = useLocalStorage(
    "shouldHighlightWords",
    true
  );

  const [shouldShowInlineDefs, setShouldShowInlineDefs] = useLocalStorage(
    "shouldShowInlineDefs",
    true
  );

  const [shouldShowLineTranslations, setShouldShowLineTranslations] =
    useLocalStorage("shouldShowLineTranslations", false);

  return {
    shouldHighlightWords,
    toggleWordHighlighting: () =>
      setShouldHighlightWords(!shouldHighlightWords),
    wordHighlightingLabel: "Toggle Word Highlighting",

    shouldShowInlineDefs,
    toggleShowInlineDefs: () => setShouldShowInlineDefs(!shouldShowInlineDefs),
    inlineDefsLabel: "Toggle Inline Defs",

    shouldShowLineTranslations,
    toggleShowLineTranslations: () =>
      setShouldShowLineTranslations(!shouldShowLineTranslations),
    lineTranslationsLabel: "Toggle Line Translations",
  };
}

export default useSettings;
